<div class="u-w--100">
  <mat-card
    class="tickets-card"
    appearance="outlined">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>{{
          localizationConstants.TECH_COVER_SUPPORT_TICKETS | translate
        }}</mat-card-title>
        <div>
          <span
            class="new-tech-cover-ticket-button button-filter"
            (click)="onNewTicketClick()">
            <span>{{ localizationConstants.TECH_COVER_NEW_TICKET_BUTTON | translate }}</span>
            <mat-icon
              svgIcon="add"
              class="new-tech-cover-ticket-button-icon"></mat-icon>
          </span>
        </div>
      </mat-card-title-group>
    </mat-card-header>
    <div class="tickets-table-container col">
      <table
        mat-table
        matSort
        [dataSource]="dataSource()"
        class="c-table">
        <ng-container
          *ngFor="let col of columns"
          [matColumnDef]="col.key">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="c-table__column-header">
            {{ col.title | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let item">
            <ng-container [ngSwitch]="col.key">
              <div
                *ngSwitchCase="'subject'"
                class="flex between">
                <div>{{ item.subject || item.caseNumber }}</div>
                <div *ngIf="item.description">
                  <button
                    mat-icon-button
                    color="primary"
                    [title]="localizationConstants.TECH_COVER_TICKET_DETAILS | translate"
                    [matMenuTriggerFor]="menu">
                    <mat-icon svgIcon="information"></mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <div class="description-popover">
                      <h6 class="tooltip-font">
                        {{ localizationConstants.TECH_COVER_TICKET_DETAILS | translate }}
                      </h6>
                      <p>{{ item.description }}</p>
                    </div>
                  </mat-menu>
                </div>
              </div>
              <div *ngSwitchCase="'status'">
                <span
                  class="ticket-status"
                  [ngClass]="item.statusClass"
                  >{{ item.statusLabel | translate }}</span
                >
              </div>
              <div *ngSwitchDefault>
                <span *ngIf="col.type === 'text'">
                  {{ item[col.key] }}
                </span>
                <span *ngIf="col.type === 'date'">
                  {{ (item[col.key] | date) || "--" }}
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="columnKeys; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: columnKeys"
          class="c-table__row"></tr>
        <tr *matNoDataRow>
          <td colspan="6">
            <div class="center">
              {{ localizationConstants.TECH_COVER_NO_TICKETS | translate }}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="10"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </mat-card>
</div>
